module.exports = __webpack_public_path__ + "img/2024-08-29c_4.11515ca9.jpg";